@if (image(); as image) {
  <mp-image
    class="avatar"
    [class]="avatarSizeCssClassObject()"
    [imagePath]="image"
    [useScaleDown]="false"
    (imageLoadError)="handleImageLoadError()"
  />
} @else if (initials()) {
  <div class="avatar" [class]="avatarSizeCssClassObject()">
    {{ initials() }}
  </div>
} @else {
  <mp-image class="avatar" [class]="avatarSizeCssClassObject()" [imagePath]="placeholderImageUrl" />
}
